let personalData = {
    title: "Personal info",
    info: "Basic Info",
    head: "Avatar",
    footerTitle: "Third-party authentication source",
    unbind: "Unbind",
    unbindSub: "Confirm to unbind ",
    source: " authentication source?",
    import: "Please enter",
    select: "Please choose",
    rulesFun: "Please enter 1-32 characters, support numbers, Chinese, upper and lower case letters, and special characters!@#$%^&*()_.",
    onlyNum: "Only enter numbers!",
    maxNum: "Maximum input 9007199254740991！",
    addSuc:"Added successfully!",
    editSuc:"Successfully modified!",
    maxLength:"At most 5 attribute values can be added!",
    requireTrue:"It is required and cannot be blank!",
    multivalue:"Support multiple attribute values",

}

export default personalData